import { z } from 'zod';

export const TransitAmendDataSchema = z.object({
  name: z
    .string()
    .min(1, { message: 'Required' })
    .regex(/^[a-zA-Z0-9-]*$/g, { message: 'Name is invalid' }),
});
export type TransitAmendData = z.infer<typeof TransitAmendDataSchema>;
